import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';

/** Bajo demanda, como Segmentos: el import va al archivo y no al barrel `@/domains/credit`. */
const CohortsPage = lazy(() =>
    import('@/domains/credit/cohorts/CohortsPage').then((m) => ({
        default: m.CohortsPage,
    })),
);

// Ruta estática: gana sobre la dinámica hermana `$section`.
export const Route = createFileRoute('/_backoffice/credit/cohorts')({
    component: CreditCohorts,
});

function CreditCohorts() {
    return (
        <Suspense fallback={<Loading fullScreen text="Cargando cohorts…" />}>
            <CohortsPage />
        </Suspense>
    );
}
